<sim-base-chip-input
	[formState]="scenarioFc"
	[label]="label"
	[placeholder]="placeholder"
	[hasGroupedValues]="true"
	[autoCompleteGroupedValues]="autoCompleteGroupedData"
	[isDisabled]="isDisabled"
	[isMultiSelect]="canSelectMultipleScenarios"
	[isAutofocusEnabled]="isAutofocusEnabled"
	(searchFieldChanged)="reloadAutoCompleteData($event)"
	(optionCleared)="optionCleared.emit()"
	(optionSelected)="optionSelected.emit($event)"
	(itemClicked)="openScenarioDialog($event)"
>
	<ng-container labelSuffix>
		<ng-content select="[labelSuffix]" />
	</ng-container>
</sim-base-chip-input>
